import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface PhotoOptionProps {
  image: string;
  label: string;
  onClick: () => void;
  selected?: boolean;
  gradient?: string;
}
export function PhotoOption({
  image,
  label,
  onClick,
  selected,
  gradient = 'from-blue-600/80 to-blue-900/80'
}: PhotoOptionProps) {
  return <motion.button onClick={onClick} whileHover={{
    scale: 1.05,
    y: -5
  }} whileTap={{
    scale: 0.98
  }} className={`relative overflow-hidden rounded-2xl w-40 h-56 group transition-all duration-300 bg-white
        ${selected ? 'ring-4 ring-[#B45092] shadow-[0_0_30px_rgba(180,80,146,0.3)]' : 'shadow-lg hover:shadow-2xl border-2 border-[#B45092]/30'}
      `} data-id="element-71">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: `url(${image})`
    }} data-id="element-72" />

      {/* Gradient Overlay */}
      <div className={`absolute inset-0 bg-gradient-to-b ${gradient} opacity-60 group-hover:opacity-50 transition-opacity duration-300`} data-id="element-73" />

      {/* Content */}
      <div className="absolute inset-0 flex flex-col items-center justify-end p-4" data-id="element-74">
        <span className="text-white font-semibold text-lg mb-2" data-id="element-75">{label}</span>
        <div className="w-8 h-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center group-hover:bg-[#B45092] transition-colors" data-id="element-76">
          <ChevronRight className="w-5 h-5 text-white" data-id="element-77" />
        </div>
      </div>
    </motion.button>;
}